// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"78ae3231","administration":"725b4aff"}[chunkId] + ".chunk.js";
};